export const VEHICLE_DOCUMENT_NAMES = [
  'cvo_coc',
  'betaalbevestiging',
  'cmr_export',
  'dhl',
  'factuur_inkomend',
  'factuur_uitgaand',
  'machtigingsformulier',
  'credit_invoice',
  'overige',
  'registratie_buitenland',
  'exa_confirmed',
  'exa_not_confirmed',
  'verslag_opname_bedrijfsvoorraad',
  'vrijwaringsbewijs',
  'purchase_agreement',
  'OFAC_check',
  'trailer_image',
  'APK_test_certificate',
  'confirmation_of_exit',
  'EX-A_douane_report',
  'power_of_attorney',
  'maintenance_history',
]




export const COMPANY_DOCUMENT_NAMES = [
  'bedrijvenformulier',
  // 'btw_uittreksel',
  'btw_summary',
  'screenshot_registered_address',
  'iban_check',
  'id',
  'kvk',
  'overig',
  'website',
  //'schermafdruk_vestigingsadres',
  'schermafdruk_vies_adres',
  'internet_data',
  'checklist_icl',
  'list_month',
  'advertentie_internet',
  'dhl',
  'vies_check',
  'overige_bescheiden'
];


export const USER_DOCUMENT_NAMES = ['ID_front', 'ID_back', 'copy_bank_card'];
